<footer class="footer-wrapper">
  <div class="footer-inner">
    <p class="copyright">© {{ year }} {{ siteOwnerName }}</p>
    <nav class="footer-links" aria-label="Footer">
      <a routerLink="/privacy">Privacy</a>
      <a [href]="linkedInProfileUrl" target="_blank" rel="noopener noreferrer">LinkedIn</a>
    </nav>
  </div>
</footer>
